import React from "react";
import { LoginState, Actions } from "../reducer";

export const LoginContext = React.createContext<{
  state: LoginState;
  dispatch: React.Dispatch<Actions>;
} | null>(null);
